const getLSKeys = () => {
    if (typeof window === 'undefined') {
        return [];
    }
    return Object.keys(window.localStorage);
};

export { getLSKeys };
